module.exports = __webpack_public_path__ + "static/media/tees.a818c013.svg";